var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPaperclipHorizontal = function SvgIconPaperclipHorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.125 7.5a1 1 0 0 1 1-1h10.5a5.5 5.5 0 0 1 0 11H4.5a3.625 3.625 0 1 1 0-7.25h12.75a1 1 0 1 1 0 2H4.5a1.625 1.625 0 1 0 0 3.25h13.125a3.5 3.5 0 1 0 0-7h-10.5a1 1 0 0 1-1-1"
  })));
};
export default SvgIconPaperclipHorizontal;